<vectronic-card [title]="title()" [displayClose]="displayClose()" (closed)="closed.emit()">
  <ng-container body>
    <div class="scroll_wrapper">
      @if (items().length === 0) {
        <div class="empty-message">{{ emptyMessage() }}</div>
      } @else {
        @for (item of itemsToShow(); track item.id ?? $index) {
          <div class="item">
            <div class="grid">
              <div class="author">
                <span>
                  {{ formatAuthor(item.author) }}
                  @if (item.timestamp) {
                    <span class="date ml-6">{{ formatTimestamp(item.timestamp) }}</span>
                  }
                </span>
              </div>
              <div>
                <span class="type">{{ item.type }}</span>
              </div>
            </div>
            <div class="details pt-6">
              <div class="text">{{ item.text }}</div>
              @if (
                item.actions?.length ||
                (canModifyComments() &&
                  (item.type === editableType() || item.type === deletableType()))
              ) {
                <div class="actions">
                  @for (action of item.actions ?? []; track action.id) {
                    <mat-icon
                      [matTooltip]="action.tooltip"
                      (click)="itemAction.emit({ actionId: action.id, item })"
                      class="icon-18 pointer"
                      color="primary"
                      >{{ action.icon }}</mat-icon
                    >
                  }
                  @if (canModifyComments() && item.type === editableType()) {
                    <mat-icon
                      color="primary"
                      (click)="editItem.emit(item)"
                      class="icon-18 mr-6 pointer"
                      >edit</mat-icon
                    >
                  }
                  @if (canModifyComments() && item.type === deletableType()) {
                    <mat-icon color="primary pointer" (click)="confirmDelete(item)" class="icon-18"
                      >close</mat-icon
                    >
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </ng-container>
  <ng-template #cardButtons>
    @if (showTypeFilter()) {
      <mat-form-field appearance="outline" class="small-form-field selection-field">
        <mat-label>Select Type</mat-label>
        <mat-select [value]="selectedType()" (selectionChange)="onChangeType($event)">
          @for (type of types(); track type.value) {
            <mat-option [value]="type.value">
              {{ type.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (canModifyComments() && showAddComment()) {
      <button mat-button (click)="addComment.emit()">
        <mat-icon color="accent" matTooltip="Add new comment" class="icon-24">add</mat-icon>
      </button>
    }
    @if (showPopOut()) {
      <button mat-icon-button matTooltip="Pop out" (click)="popOut.emit()">
        <mat-icon color="accent">open_in_new</mat-icon>
      </button>
    }
  </ng-template>
</vectronic-card>
